import { getFileKindFromRow } from '../services/templatesImportsService';

/** Singular noun per import type, as it reads in "<Title> <Noun> Template". */
export const IMPORT_TYPE_TEMPLATE_NOUNS = {
  'cost-groups': 'Cost Group',
  schedules: 'Schedule',
  dashboards: 'Dashboard',
  todos: "To-Do's",
  workflows: 'Workflow',
};

const squash = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, '');

/** True when the title already names its type, e.g. "ADU Schedule" or "Sales Dashboard". */
const titleEndsWithNoun = (title, noun) => {
  const t = squash(title);
  const n = squash(noun).replace(/s$/, '');
  return t.endsWith(n) || t.endsWith(`${n}s`);
};

/** "Schedule", "To-Do's"… for an import row (bootcamp rows carry `importType`, CRM rows `tabId`). */
export function templateImportTypeNoun(row) {
  return IMPORT_TYPE_TEMPLATE_NOUNS[row?.importType ?? row?.tabId] || '';
}

/**
 * Save-as name for a JobTread import: the template's title plus what kind of
 * template it is — "Employee Exit Interview To-Do's Template.csv". Never the
 * uploaded file's name, which is usually a JobTread export like
 * "tasks-taskTemplate-22PXm5M3CDZ3-2026-06-29 (1).csv".
 */
export function templateImportFileName(row) {
  const ext = getFileKindFromRow(row) === 'json' ? 'json' : 'csv';
  const rawTitle = String(row?.title || '').trim();
  // Uploads without a title store the file's own name as the title — that's the
  // junk this helper exists to hide, so treat it as no title at all.
  const titleIsFileName = rawTitle && rawTitle === String(row?.fileName || '').trim();
  const title = Array.from(titleIsFileName ? '' : rawTitle)
    .slice(0, 120) // by code point, so an emoji is never split in half
    .join('')
    .replace(/\.(json|csv)$/i, '')
    .replace(/[\\/:*?"<>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/[\s.]+$/, '')
    .replace(/\s*\btemplates?$/i, '')
    .replace(/[\s.]+$/, '');
  const noun = templateImportTypeNoun(row);
  const parts = [title || 'JobTread'];
  if (noun && !titleEndsWithNoun(title, noun)) parts.push(noun);
  parts.push('Template');
  return `${parts.join(' ')}.${ext}`;
}
